import React, {useState} from 'react';
import {Col, Container, Form, Row} from 'react-bootstrap';
import {ActionResult, HttpMethod} from "../../model";
import {httpClient} from "../../service";
import CouponcodeVerifyList from "./CouponcodeList";
import parse from 'html-react-parser';
import {Link} from 'react-router-dom';

const CouponcodeVerify = () => { // 추가
    const [fileName, setFileName] = useState("엑셀코드파일 업로드");
    const [validated, setValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [action, setAction] = useState<ActionResult>();
    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();
        const files = e.target.files;
        const form = e.target.form;
        setSubmitting(true);
        const formData = new FormData();
        const fileObj = files[0];
        formData.append("attachFile", fileObj, fileObj.name);

        const url = 'test/verifications/coupon/code';

        setFileName('업로드중...');
        const option = {
            method: HttpMethod.POST,
            url,
            body: formData,
            isMultipart: true
        }

        const act = await httpClient(option);
        setAction(act);
        setSubmitting(false);
        setFileName('엑셀코드파일 업로드');
        e.target.value = null;
        form.reset();
    }
    const listHtml = action ? <CouponcodeVerifyList submitting={submitting}
                                                    action={action}/> : parse(`<div class="center">엑셀코드 파일을 업로드하세요.</div>`);
    return (
        <>
            <div className="bloc l-bloc">
                <Container className="bloc-sm">
                    <div className="row">
                        <Col className="text-left col-sm-12 mb-1">
                            <Link to="/verifications" className="btn btn-sm btn-primary">Home</Link>
                        </Col>
                        <div className="col-sm-12">
                            <Form id="form_539" data-form-type="blocs-form" noValidate validated={validated}>
                                <Form.Group>
                                    <Form.File
                                        type="file"
                                        id="inputGroupFile01"
                                        label={fileName}
                                        onChange={submitForm}
                                        custom
                                        disabled={submitting}
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            {listHtml}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
};

export default CouponcodeVerify;
